import { FC, useMemo } from "react";

import { CreateGUFHeightTask, EditGUFHeightTask } from "@nens/brostar/uploadapi-client";

import { getApi } from "@/api/api-configuration";
import { getFormObjectValues, initializeFormEditingState } from "@/helpers/helpers";
import { useAfterFormSubmit } from "@/hooks/use-after-form-submit";
import { BrostarForm, useBrostarFormDataStorage } from "@/libs/brostar-form";
import { GufHeightFormProps } from "@/types/form-types";

import { getGufHeightSchema } from "../schema/guf-height-schema";
import { useGufHeightUiSchema } from "../schema/guf-height-ui-schema";
import { validateGufHeightForm } from "../schema/guf-validation";

const GufHeightForm: FC<GufHeightFormProps> = (props) => {
  const api = getApi();
  const afterSubmit = useAfterFormSubmit();

  const { oldUploadTask, task, type } = getFormObjectValues(props);
  const { isEditing, getIsEditing } = initializeFormEditingState(props);

  const { formData, handleChange } = useBrostarFormDataStorage<
    CreateGUFHeightTask | EditGUFHeightTask
  >({
    key: "guf-height",
    task,
  });

  const uiSchema = useGufHeightUiSchema(formData?.metadata.qualityRegime);

  const schema = useMemo(() => getGufHeightSchema({ type, isEditing }), [type, isEditing]);

  const onSubmit = async () => {
    if (!formData) return;
    if (getIsEditing(formData)) {
      await api.editGUFHeight(formData);
    } else {
      await api.createGUFHeight(formData);
    }
    if (oldUploadTask?.uuid) api.apiUploadtasksDelete({ uuid: oldUploadTask.uuid });
    await afterSubmit();
  };

  return (
    <BrostarForm<CreateGUFHeightTask | EditGUFHeightTask>
      uploadTask={oldUploadTask}
      schema={schema}
      formData={formData}
      onChange={handleChange}
      uiSchema={uiSchema}
      onSubmit={onSubmit}
      customValidate={validateGufHeightForm}
    />
  );
};

export { GufHeightForm };
